module.exports = __webpack_public_path__ + "static/media/icon-always-on.20a6bf26.svg";